var _polygon, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#646464",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-octagon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#a4a4a4",
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "#a4a4a4",
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOctagon);
export default __webpack_public_path__ + "static/media/alert-octagon.df2fca64b132b438ce047382c23e39c5.svg";
export { ForwardRef as ReactComponent };